<div class="container-fluid mt-3 mb-3 theme">
  <div class="row nowrap mt-4 mb-3" aria-label="breadcrumb">
    <div class="col-lg-10">
      <div class="d-flex">
        <h1>Half Yearly Networth</h1>
        <ul class="breadcrumbcustom" role="navigation" aria-labelledby="breadcrumb">
          <li><a routerLink="">Home</a></li>
          <li><a routerLink="">Enit</a></li>
          <!-- <li *ngIf="entityType=='ADMIN'"class="active"><a routerLink="complianceAdmin/halfYearlyNetworthAdmin/halfYearlyNetworthList/halfYearlyReport" aria-current="page">Half Yearly Networth Report</a></li> -->

          <!-- <li *ngIf="entityType=='ENIT'" class="active"><a routerLink="eCompliance/halfYearlyReport/halfYearlyNetworthReport/halfYearlyReportMember" aria-current="page">Half Yearly Networth Report</a></li> -->

        </ul>
      </div>

    </div>
  </div>


  <div class="container-fluid mt-3 mb-3 theme">
    <div class="card card-body col-lg-12 mt-3 colorborder">
      <form [formGroup]="halfYearlyForm">
        <fieldset [attr.disabled]="true">
          <div class="column col-lg-12">

            <div class="row">
              <div class="col-lg-4 form-group">
                <label for="memberName">Member Name</label>
                <input class="form-control" readonly formControlName="memberName" id="memberName">
              </div>
              <div class="col-lg-2 form-group">
                <label for="memberCode">Member Code</label>
                <input type="text" class="form-control" readonly id="memberCode"
                  formControlName="memberCode">
                </div>
                <!-- Networth Changes minNetworth-->
                <div class="col-lg-2 form-group">
                  <label for="memCategory">Member Category</label>
                  <input class="form-control" readonly id="memCategory" formControlName="memCategory">
                </div>
                <div class="col-lg-2 form-group">
                  <label for="minNetworth">Minimum Networth Requirement</label>
                  <input class="form-control" readonly id="minNetworth" formControlName="minNetworth">
                </div>
                <div class="col-lg-2 form-group">
                  <label for="asOnDate">As On Date</label>
                  <input type="text" class="form-control" readonly formControlName="asOnDate"
                    id="asOnDate">
                  </div>
                </div>
              </div>


              <div class="row">


                <div class="column col-lg-6">

                  <div class="col-lg-12 form-group">
                    <label for="nameOfCaFirm">Name of CA Firm</label>
                    <input class="form-control" id="nameOfCaFirm" formControlName="nameOfCaFirm">
                  </div>
               @if (this.f.version.value == '1'){
                  <div class="col-lg-12 form-group">
                     <label for="udin">UDIN No</label>
                     <input class="form-control" id="udin" formControlName="udin">
                  </div>
                }

                  <div class="col-lg-12 form-group">
                    <label for="membershipNoCertifyingCa">Membership No. of Certifying CA</label>
                    <input type="text" class="form-control" formControlName="membershipNoCertifyingCa"
                      id="membershipNoCertifyingCa">
                    </div>


                  </div>



                  <div class="column col-lg-6">

                    <div class="col-lg-12 form-group">
                      <label for="reasonFor25variation">If 25% variation in networth compared to previous
                      submission, please provide reason</label>
                      <br>
                        <div>

                          <textarea class="form-control" contenteditable
                            formControlName="reasonFor25variation" id="reasonFor25variation" cols="50"
                          rows="5"></textarea>
                        </div>
                      </div>

                    </div>



                  </div>

                </fieldset>
                <hr>

           @if (this.f.version.value == '0'){
                   <div class="col-lg-4 form-group">
                    <label>IFSC CMI</label>
                    <input type="text" class="form-control" formControlName="changeCMIRequest" readonly>
                  </div> 
                }

                  <hr>
                     @if (this.f.version.value == '0' && this.f.changeCMIRequest.value =='IFSC_CMI_2021') {
                      <div>
                        <h6>Computation of Networth as per IFSCA (Capital Market Intermediaries) Regulations, 2021</h6>
                        <fieldset [attr.disabled]="true">
                          <div class="row">
                            <div class="col-lg-6">
                              <table class="table table-stripped table-bordered">
                                <thead>
                                  <tr>
                                    <th width="70%">Particulars</th>
                                    <th width="30%">Amount in USD $</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td><b>Paid up share capital or capital contribution</b>
                                  </td>
                                  <td><input type="number" name="paidUpCapital"
                                    formControlName="paidUpCapital" id="paidUpCapital"
                                  class="form-control"></td>
                                </tr>
                                <tr>
                                  <td>Reserves created out of the profit<span class="red">*</span></td>
                                  <td><input type="number" name="reservedCreatedOfProfit"
                                    formControlName="reservedCreatedOfProfit" id="reservedCreatedOfProfit"
                                  class="form-control"></td>
                                </tr>
                                <tr>
                                  <td>Credit balance of profit and loss account</td>
                                  <td><input type="number" name="cerditBalanceProfitAndLoss"
                                    formControlName="cerditBalanceProfitAndLoss"
                                  id="cerditBalanceProfitAndLoss" class="form-control"></td>
                                </tr>
                                <tr>
                                  <td>Securities premium account</td>
                                  <td><input type="number" name="securityPermium"
                                    formControlName="securityPermium" id="securityPermium"
                                  class="form-control"></td>
                                </tr>
                                <tr>
                                  <td><b>Total - A </b></td>
                                  <td><input type="number" name="totalA" readonly="readonly" id="totalA"
                                  formControlName="totalA" class="form-control"></td>
                                </tr>
                              </tbody>
                            </table>
                            <span class="red">*</span><span>Reserves created out of revaluation of assets, write-back of depreciation and amalgamation shall not be included</span>
                          </div>
                          <div class="col-lg-6">
                            <table class="table table-stripped table-bordered width">
                              <thead>
                                <tr>
                                  <th width="70%">Particulars</th>
                                  <th width="30%">Amount in USD $</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>Aggregate value of accumulated losses</td>
                                  <td><input type="number" name="accumulatedLosses"
                                    formControlName="accumulatedLosses" id="accumulatedLosses"
                                  class="form-control"></td>
                                </tr>
                                <tr>
                                  <td>Deferred expenditure not written off</td>
                                  <td><input type="number" name="deferredExpenditure"
                                    formControlName="deferredExpenditure" id="deferredExpenditure"
                                  class="form-control"></td>
                                </tr>
                                <tr>
                                  <td>Miscellaneous expenses not written off</td>
                                  <td><input type="number" name="miscellaneousExpenses"
                                    formControlName="miscellaneousExpenses" id="miscellaneousExpenses"
                                  class="form-control"></td>
                                </tr>
                                <tr>
                                  <td>Minimum net worth requirements applicable for other activities outside IFSC
                                  </td>
                                  <td><input type="number" name="otherActivitiesOutsideIfsc"
                                    formControlName="otherActivitiesOutsideIfsc"
                                  id="otherActivitiesOutsideIfsc" class="form-control"></td>
                                </tr>
                                <tr>
                                  <td><b>Total - B </b></td>
                                  <td><input type="number" name="totalB" readonly="readonly"
                                  formControlName="totalB" id="totalB" class="form-control"></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div class="col-lg-12">
                            <table class="table table-stripped table-bordered width">
                              <tbody>
                                <tr>
                                  <td>Total Networth (A-B)</td>
                                  <td><input type="number" name="totalNetworth" formControlName="totalNetworth"
                                  readonly="readonly" id="totalNetworth" class="form-control"></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  } 
                    @if (this.f.version.value == '0' && this.f.changeCMIRequest.value =='IFSC_CMI_2025') {
	                  <div>
	                    <h6> Computation of Networth as on March 31, 2025 </h6>
	                    <fieldset [attr.disabled]="true">
	                      <div>
	                        <div class="col-lg-12">
	                          <table class="table table-stripped table-bordered width">
                            <thead>
	                              <tr>
	                                <th width="70%">Particulars</th>
	                                <th width="30%">Amount in USD</th>
	                              </tr>
	                            </thead>
	                            <tbody>
	                              <tr>
	                                <td>Aggregate value of Liquid Assets
	                                </td>
	                                <td><input type="number" name="liquidAssets"
                                  (change)="validateNumber($event)" (input)="totalAcal()"	                 
                                       formControlName="liquidAssets" id="liquidAssets"
	                                class="form-control"></td>
	                              </tr>
	                              <tr>
	                                <td>Cash & Bank Balance</td>
	                                <td><input type="number" name="cashBankBal"
	                                  (change)="validateNumber($event)" (input)="totalAcal()"
	                                  formControlName="cashBankBal" id="cashBankBal"
	                                class="form-control"></td>
	                              </tr>
	                              <tr>
	                                <td>Fixed Deposits</td>
	                                <td><input type="number" name="fixedDeposits"
	                                  (change)="validateNumber($event)" (input)="totalAcal()"
                                  formControlName="fixedDeposits" id="fixedDeposits"
	                                class="form-control"></td>
	                              </tr>
	                              <tr>
	                                <td>Government Securities</td>
	                                <td><input type="number" name="goverSecurities" (change)="validateNumber($event)"
	                                  (input)="totalAcal()" formControlName="goverSecurities" id="goverSecurities"
	                                class="form-control"></td>
                              </tr>
	                              <tr>
	                                <td><b>Total Networth</b></td>
	                                <td><input type="number" name="totalNetworth2025" (change)="validateNumber($event)"
	                                  readonly="readonly" id="totalNetworth2025" formControlName="totalNetworth2025"
	                                class="form-control"></td>
	                              </tr>
	                            </tbody>
	                          </table>
	                          @if (alert) {
	                            <p class="center">Total Networth is less than Minimum Networth Requirement which is ${{limit}}</p>
	                          }
	                        </div>
	                      </div>
	                    </fieldset>
	                  </div>
	                }

                @if (this.f.version.value == '1') {
                  <div>
                    <h6>Computation of Net Worth as per IFSCA (Capital Market Intermediaries) Regulations, 2025 as on March 31, 2026</h6>
                    <fieldset [attr.disabled]="true">
                      <div>
                        <div class="col-lg-12">
                          <table class="table table-stripped table-bordered width">
                            <thead>
                              <tr>
                                <th width="70%">Particulars</th>
                                <th width="30%">Amount in USD</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td><b>A    Aggregate value of Liquid Assets as mentioned below:</b>
                                </td>
                              </tr>
                              <tr>
                                  <td>Add :
                                    </td>
                                </tr>
                              <tr>
                                <td>(a)     Cash & Bank Balance</td>
                                <td><input type="number" name="cashBankBal"
                                  formControlName="cashBankBal" id="cashBankBal"
                                class="form-control"></td>
                              </tr>
                              <tr>
                                <td>(b)     Fixed Deposits</td>
                                <td><input type="number" name="fixedDeposits"
                                  formControlName="fixedDeposits" id="fixedDeposits"
                                class="form-control"></td>
                              </tr>
                              <tr>
                                <td>(c)     Government Securities</td>
                                <td><input type="number" name="goverSecurities" 
                                   formControlName="goverSecurities" id="goverSecurities"
                                class="form-control"></td>
                              </tr>
                             <tr>
                                  <td>(d)     Margin maintained by the registered Broker Dealer/Clearing Member in relation to their trading activities in the IFSC or Global Access</td>
                                  <td><input type="number" name="marginTrading"  
                                    formControlName="marginTrading" id="marginTrading"
                                  class="form-control"></td>
                                </tr>

                                <tr>
                                  <td>(e)     Base Minimun Capital and Interest Free Deposit maintained by the registered broker dealers and the registered clearing members with the recognised stock exchanges and clearing corporations respectively</td>
                                  <td><input type="number" name="baseMinimumCapital" 
                                   formControlName="baseMinimumCapital" id="baseMinimumCapital"
                                  class="form-control"></td>
                                </tr>
                              <tr>
                                <td><b>Total-A</b></td>
                                <td><input type="number" name="totalNetworth2025" 
                                  readonly="readonly" id="totalNetworth2025" formControlName="totalNetworth2025"
                                class="form-control"></td>
                              </tr>
                                 <tr>
                                    <td><b>B         Less</b>
                                    </td>
                                    <!-- <td><input type="number" name="liquidAssets"
                                    (change)="validateNumber($event)" (input)="totalAcal()"
                                    formControlName="liquidAssets" id="liquidAssets"
                                  class="form-control"></td> -->
                                </tr>
                                  <tr>
                                  <td>(a)         Liabilities</td>
                                  <td><input type="number" name="liabilities" 
                                    formControlName="liabilities" id="liabilities"
                                  class="form-control"></td>
                                </tr>
                                 <tr>
                                  <td><b>Total-B</b></td>
                                  <td><input type="number" name="totalNetworth2025B" 
                                    readonly="readonly" id="totalNetworth2025B" formControlName="totalNetworth2025B"
                                  class="form-control"></td>
                                </tr>

                                <tr>
                                  <td><b>C              Total Networth A-B</b></td>
                                  <td><input type="number" name="totalNetworth2025AB" 
                                    readonly="readonly" id="totalNetworth2025AB" formControlName="totalNetworth2025AB"
                                  class="form-control"></td>
                                </tr>
                            </tbody>
                          </table>
                          @if (alert) {
                            <p class="center">Total Networth is less than Minimum Networth Requirement which is ${{limit}}</p>
                          }
                        </div>
                      </div>
                    </fieldset>
                  </div>
                 } 
                <div class="row">

                  <!-- <div *ngIf="makerCommentFlag || checkerCommentFlag"> -->
                  <!-- <div *ngIf="makerCommentFlag" class="column col-lg-6"> -->

                  <div class="col-lg-12 form-group">
                    <label for="commentForMaker"></label>
                    <br>
                      <div>

                        <textarea class="form-control" contenteditable formControlName="commentForMaker"
                        id="commentForMaker" cols="50" rows="5" [readonly]="true"></textarea>
                      </div>
                    </div>

                  <!-- </div> -->


                  <!-- <div *ngIf="checkerFlag" class="column col-lg-6"> -->

                  <div class="col-lg-12 form-group">
                    <label for="commentForChecker"></label>
                    <br>
                      <div>

                        <textarea class="form-control" contenteditable formControlName="commentForChecker"
                        id="commentForChecker" cols="50" rows="5" [readonly]="true"></textarea>
                      </div>
                    </div>

                  <!-- </div> -->
                <!-- </div> -->


                <br>
                  <div class="text-right col-lg-4 text-right">
                    <button class="btn btn-primary" (click)="back()">Back</button>
                  </div>

                </div>

              </form>
            </div>
          </div>







        </div>